import { render } from "./chart_double.vue?vue&type=template&id=6d966446&scoped=true"
const script = {}

import "./chart_double.vue?vue&type=style&index=0&id=6d966446&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d966446"]])

export default __exports__